const useGetRetinalExamDataModelConfig = () => {
  const deviceDataModelId = import.meta.env
    .VITE_MODEL_ID_RETINAL_EXAM_TELEOPHTH;

  const examSubmissionPropertySetId = import.meta.env
    .VITE_PROPERTY_SET_ID_EXAM_SUBMISSION_RETINAL_EXAM_TELEOPHTH;

  return {
    deviceDataModelId,
    examSubmissionPropertySetId,
  };
};

export default useGetRetinalExamDataModelConfig;
